import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(
    createStyles({
        container: {
            padding: 18,
            border: '1px solid #E5E5E5',
            borderRadius: 1,
            background: '#FFF',
            boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.15)',
            width: '100%',
            boxSizing: 'border-box'
        }
    })
)
